import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CarmValidatorsList } from '@carm/_utils/error-handler/validations/carm-validators';
import { IFilterSearchCriteria } from './models/table-filter.model';
import { Destroyable } from '@carm/_core/destroyable';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterOptions, KeyValue } from '@carm/_core';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'carm-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
})

export class TableFilterComponent extends Destroyable implements OnInit {

  @Input() filterOptions: FilterOptions[];
  @Input() inId: string;
  // Emmits event when one of the search button in the filter bar is clicked, contains the field and value
  @Output() searchButtonClicked = new EventEmitter<IFilterSearchCriteria>();
  @Output() clearButtonClicked = new EventEmitter();

  filterForm: UntypedFormGroup;
  isExpand = false;
  selectOptions: KeyValue[] = null;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
     super();
  }

  ngOnInit() {
    this.createForm();

    const filterSearchModel = this.getSearchModelFromUrl();
    if(filterSearchModel){
      this.isExpand = true;
      this.filterForm.patchValue(filterSearchModel);
      this.searchButtonClicked.emit(filterSearchModel);
    }

  }

  private createForm() {
    this.filterForm = this.fb.group({
      criteriaField: [null, [CarmValidatorsList.required.validateFn]],
      criteriaValue: ['', [CarmValidatorsList.required.validateFn]]
    });
    if (this.filterOptions.some(c => !!c.options)) {
      this.prepareSelectField();
    }
  }

  private prepareSelectField(): void {
    this.filterForm.controls.criteriaField.valueChanges
    .pipe(takeUntil(this._destroyed$))
    .subscribe(selected => {
      this.filterForm.controls['criteriaValue'].setValue(null);
      this.selectOptions = this.filterOptions.find(c => c.key === selected)?.options?.slice();
    });
  }

  public getFormData(): IFilterSearchCriteria {

    if(!this.filterForm){
      return null;
    }

    return {
      componentId: this.inId,
      criteriaField: this.filterForm.controls.criteriaField.value,
      criteriaValue: this.filterForm.controls.criteriaValue.value
    }
  }

  searchButtonHandler() {
    if (this.filterForm.valid) {
      const formValue = this.filterForm.value;
      if (formValue.criteriaField && formValue.criteriaField !== ''
        && formValue.criteriaValue && formValue.criteriaValue !== '') {
          this.persistSearchModelInUrl(this.filterForm.value);
          this.searchButtonClicked.emit(formValue);
     }
    }
  }

  // Clears all values
  clearButtonHandler() {
    this.filterForm.controls['criteriaField'].setValue(null);
    this.filterForm.controls['criteriaValue'].setValue(null);
    this.clearButtonClicked.emit(this.filterForm.value);
    this.clearSavedUrlParams();
  }


  private persistSearchModelInUrl(filterSearchModel: IFilterSearchCriteria) : void {
    filterSearchModel.componentId = this.inId;

    const encodedSearchParams = {
      filterSearch: btoa(JSON.stringify(filterSearchModel))
    }

    this.router.navigate([], {
      queryParams: encodedSearchParams,
      queryParamsHandling: 'merge',
      fragment: this.inId,
      replaceUrl: true
    });
  }

  private clearSavedUrlParams() : void {

    const currentSearchParams = this.getSearchModelFromUrl();

    if(currentSearchParams){
      const blankSearchParams = {
        filterSearch: undefined
      }

      this.router.navigate([], {
        queryParams: blankSearchParams,
        queryParamsHandling: 'merge',
        fragment: this.inId,
        replaceUrl: true
      });
    }
  }


  private getSearchModelFromUrl(): IFilterSearchCriteria {
    const encodedSearchParams = this.activatedRoute.snapshot.queryParams?.filterSearch;

    if(encodedSearchParams){
      const filterSearch = JSON.parse(atob(encodedSearchParams)) as IFilterSearchCriteria;

      if(filterSearch.componentId === this.inId){
        return filterSearch;
      }
    }

    return null;
  }
}
